import { Trans } from '@lingui/macro';
import React, { FunctionComponent, useState } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { isGettyClient } from '@helpers/getty-strings';

import classes from './styles/brandguide-announcement.module.scss';

export const BrandguideAnnouncement: FunctionComponent = () => {
  const key = 'bf-boulder-brandguide-v2-announcement-round-4';

  const [show, setShow] = useState(localStorage.getItem(key) === 'false' ? false : true);

  const handleDismiss = (): void => {
    setShow(false);
    localStorage.setItem(key, 'false');
  };

  if (!show) return null;

  const href = isGettyClient()
    ? 'https://damhelp.gettyimages.com/hc/en-us/articles/14012721989261'
    : 'https://help.smartsheet.com/12052930317463-Getting-Started-with-Brandguide';

  return (
    <I18nProviderWrapper>
      <div className={classes.brandguideAnnouncement}>
        <p className={classes.brandguideAnnouncementText}>
          <Trans>
            <span aria-hidden className={classes.brandguideAnnouncementEmoji} role="img">🚨</span>{' '}
            <strong className={classes.brandguideAnnouncementAction}>Action Required</strong>{' '}
            <span aria-hidden className={classes.brandguideAnnouncementEmoji} role="img">🚨</span>{' '}
            Brandguides on the previous editor are now in <em>read-only mode</em>.{' '}
            <a
              className={classes.brandguideAnnouncementLink}
              href={href}
              rel="noreferrer"
              target="_blank"
            >
              Migrate your Brandguide
            </a>{' '}to the latest version before deletion on December 1, 2023.
          </Trans>
        </p>
        <button
          className={classes.brandguideAnnouncementButton}
          onClick={(): void => handleDismiss()}
          type="button">
            x
        </button>
      </div>
    </I18nProviderWrapper>
  );
};
